module.exports = __webpack_public_path__ + "static/img/5Ownership-Penetration.4366ca85.gif";